import app from './app-reducer';

export * from './app-reducer';
export default app;
